



export default function CharacterDesgin() {
    return (
        <>
            <div className="ch-bg2">
                <div className="chld2">
                    <p className="cd">Character Designs</p>
                    <a href="/"><button  className="left-slide"><img src="back_arrow.svg" /><p>Back</p></button></a>
                    <img src="doodles01.jpg" className="bg_ch" />
                    <div className="cd_bg">
                        <h4 className="title"><span>✦</span>Character Concepts<span>✦</span></h4>
                        <img className="cd_01" src="Character_Concepts.jpg" />
                        <h4 className="st_1"><span>✦</span>My Art-Style<span>✦</span></h4>
                    </div>
                    <div className="cd_bg2">
                        <h4 className="title"><span>✦</span>Character Concept<span>✦</span></h4>
                        <img className="cd_01" src="Illustration175.jpg" />
                        <h4 className="st_1"><span>✦</span>My Art-Style<span>✦</span></h4>
                    </div>
                    <div className="cd_bg3">
                        <h4 className="title"><span>✦</span>Character Design<span>✦</span></h4>
                        <img className="cd_01" src="character design.jpg" />
                        <h4 className="st_1"><span>✦</span>Anime Art-Style<span>✦</span></h4>
                    </div>
                    <div className="cd_bg4">
                        <h4 className="title"><span>✦</span>Rough Character Designs<span>✦</span></h4>
                        <img className="cd_01" src="Rough Designs.jpg" />
                        <h4 className="st_1"><span>✦</span>My Art-Style<span>✦</span></h4>
                    </div>
                    <div className="cd_bg5">
                        <h4 className="title"><span>✦</span>Rough-Realstic Character Design<span>✦</span></h4>
                        <img className="cd_01" src="realstic_.jpg" />
                        <h4 className="st_1"><span>✦</span>My Art-Style<span>✦</span></h4>
                    </div>
                    <div className="cd_bg6">
                        <h4 className="title"><span>✦</span>Character Design<span>✦</span></h4>
                        <img className="cd_01" src="Character Design 01.2.jpg" />
                        <h4 className="st_1"><span>✦</span>My Art-Style<span>✦</span></h4>
                    </div>
                    <div className="cd_bg7">
                        <h4 className="title"><span>✦</span>Character Design<span>✦</span></h4>
                        <img className="cd_01" src="Character Design 01.jpg" />
                        <h4 className="st_1"><span>✦</span>My Art-Style<span>✦</span></h4>
                    </div>
                    <div className="cd_bg8">
                        <h4 className="title"><span>✦</span>Character Design<span>✦</span></h4>
                        <img className="cd_01" src="Character Design 02.jpg" />
                        <h4 className="st_1"><span>✦</span>My Art-Style<span>✦</span></h4>
                    </div>
                    <div className="cd_bg9">
                        <h4 className="title"><span>✦</span>Character Design<span>✦</span></h4>
                        <img className="cd_01" src="Character Design 03.jpg" />
                        <h4 className="st_1"><span>✦</span>My Art-Style<span>✦</span></h4>
                    </div>
                    <div className="cd_bg10">
                        <h4 className="title"><span>✦</span>Character Design<span>✦</span></h4>
                        <img className="cd_01" src="Character Design 04.jpg" />
                        <h4 className="st_1"><span>✦</span>My Art-Style<span>✦</span></h4>
                    </div>
                    <div className="cd_bg11">
                        <h4 className="title"><span>✦</span>Expression Sheet<span>✦</span></h4>
                        <img className="cd_01" src="expression_sheet_01.jpg" />
                        <h4 className="st_1"><span>✦</span>My Art-Style<span>✦</span></h4>
                    </div>
                    <div className="last"></div>
                </div>
            </div>
        </>
    );
}
